const ORDER_INTENT_KEYWORDS = ['order', 'delivery', 'arrive', 'when', 'status', 'next', 'week'];

export function isOrderIntent(input: string): boolean {
  const lower = input.toLowerCase();
  return ORDER_INTENT_KEYWORDS.some(k => lower.includes(k));
}
